import { FC, memo } from 'react'
import { useTranslate } from 'react-admin'
import { NodeProps, Position } from '@xyflow/react'
import BuildIcon from '@mui/icons-material/Build'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import Chip from '@mui/material/Chip'
import Box from '@mui/material/Box'
import BaseNode from './BaseNode'
import { ToolCallNodeData } from '../types'
import { WORKFLOW } from '../tokens'
import { xxllncColor } from '../../../layout/theme/color'

const ToolCallNode: FC<NodeProps> = ({ id, data, selected }) => {
  const translate = useTranslate()
  const nodeData = data as ToolCallNodeData
  const subtitle = nodeData.serverName && nodeData.toolName
    ? `${nodeData.serverName} → ${nodeData.toolName}`
    : 'Select a tool...'

  const paramCount = Object.keys(nodeData.parameters).length
  const isTested = (nodeData.lastOutputFields?.length ?? 0) > 0

  return (
    <BaseNode
      nodeType="tool_call"
      icon={<BuildIcon fontSize="small" />}
      label={nodeData.label}
      nodeId={id}
      subtitle={subtitle}
      selected={selected}
      handles={[
        { type: 'target', position: Position.Top },
        { type: 'source', position: Position.Bottom },
      ]}
    >
      {(paramCount > 0 || isTested) && (
        <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
          {paramCount > 0 && (
            <Chip
              label={`${paramCount} parameter${paramCount !== 1 ? 's' : ''}`}
              size="small"
              sx={{
                height: 22,
                fontSize: 11,
                fontWeight: 500,
                background: WORKFLOW.tool_call.bg,
                color: WORKFLOW.tool_call.accent,
              }}
            />
          )}
          {isTested && (
            <Chip
              icon={<CheckCircleIcon sx={{ fontSize: 13 }} />}
              label={translate('workflow.nodes.tested')}
              size="small"
              sx={{
                'height': 22,
                'fontSize': 11,
                'fontWeight': 500,
                'background': xxllncColor.opGreen10,
                'color': xxllncColor.green100,
                '& .MuiChip-icon': { color: xxllncColor.green100 },
              }}
            />
          )}
        </Box>
      )}
    </BaseNode>
  )
}

export default memo(ToolCallNode)
